import { Card, Link, Typography, Box } from '@mui/material';

import GatewaySeverityIndicator from '@/components/indicators/GatewaySeverityIndicator';

const NoTreeFoundCard = ({
  setCreateFirstNodeDialogOpen,
  selectedEnergyGroup,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Typography variant="subtitle1">Manglende opsætning</Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2, // adds spacing below the icon
        }}
      >
        <GatewaySeverityIndicator severity="medium" />
      </Box>
      <Typography variant="body2" color="textSecondary" mb={2}>
        Den valgte energigruppe <b>{selectedEnergyGroup.name}</b> er muligvis
        ikke sat op til at vise denne side.
      </Typography>
      <Link
        sx={{ cursor: 'pointer' }}
        underline="hover"
        onClick={() => setCreateFirstNodeDialogOpen(true)}
      >
        Start med at tilføje den første node til dit træ
      </Link>
    </Card>
  );
};

export default NoTreeFoundCard;
